import { WorkbenchProvider } from '@gusto/workbench';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import NoMatch from 'helpers/no_match';
import Layout from './components/layout';
import PartnerForm from './components/partner_form';

export default function App({
  domains,
  brandRefreshSkin,
}: {
  domains: string[];
  brandRefreshSkin: boolean;
}) {
  return (
    <BrowserRouter basename="/partners/signup">
      <WorkbenchProvider>
        <Routes>
          <Route path="/" element={<Layout brandRefreshSkin={brandRefreshSkin} />}>
            <Route path="/form" element={<PartnerForm ssoDomains={domains} />} />
            <Route path="*" element={<NoMatch packageName="PartnerSignup" />} />
          </Route>
        </Routes>
      </WorkbenchProvider>
    </BrowserRouter>
  );
}
